import { render, staticRenderFns } from "./GamePostView.vue?vue&type=template&id=18daca96&scoped=true&"
import script from "./GamePostView.vue?vue&type=script&lang=js&"
export * from "./GamePostView.vue?vue&type=script&lang=js&"
import style0 from "./GamePostView.vue?vue&type=style&index=0&id=18daca96&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18daca96",
  null
  
)

export default component.exports